/* eslint-disable import/prefer-default-export */
export function numberToFixed(value, numberOfDecimal = 2) {
  return Number(Number(value).toFixed(numberOfDecimal))
}
